const RISKS = [
  {
    icon: "ri-file-warning-line",
    stat: "$1,000/day",
    title: "Florida Statute 720.303",
    body:
      "HOAs with 100+ parcels must publish official records online. Missed uploads can trigger civil fines and unit-owner lawsuits.",
  },
  {
    icon: "ri-scales-3-line",
    stat: "$75,000+",
    title: "ADA Title III demand letters",
    body:
      "South Florida is the #1 US jurisdiction for website accessibility lawsuits. A single non-compliant PDF can invite a serial plaintiff.",
  },
  {
    icon: "ri-group-line",
    stat: "80/20 Rule",
    title: "HOPA 55+ housing",
    body:
      "Age-restricted communities must publish policy statements, occupancy surveys and age-verification procedures on their website.",
  },
  {
    icon: "ri-lock-2-line",
    stat: "SB 4-D",
    title: "Structural & reserve disclosures",
    body:
      "Milestone inspections, SIRS reports, and reserve funding schedules must be securely accessible to owners.",
  },
];

export default function RiskSection() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-primary-700 font-semibold">
              <i className="ri-alarm-warning-line" />
              The compliance gap
            </span>
            <h2 className="mt-4 font-heading text-4xl md:text-5xl font-semibold text-foreground-950 leading-[1.05]">
              Most South Florida association websites are one demand letter away from a crisis.
            </h2>
            <p className="mt-6 text-foreground-700 text-lg leading-relaxed">
              Between updated Florida statutes, escalating ADA litigation, and HOPA reporting duties for 55+
              communities, the average board relies on a website that hasn't been audited in years, often built by
              a volunteer or hosted on a personal account, leaving critical disclosures missing.
            </p>
            <p className="mt-4 text-foreground-700 text-lg leading-relaxed">
              We fix that. Quietly, thoroughly, and with a paper trail your attorney will love.
            </p>

          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {RISKS.map((r, idx) => (
              <div
                key={r.title}
                className={`rounded-lg border border-background-200 p-6 transition-transform hover:-translate-y-1 ${
                  idx % 3 === 0
                    ? "bg-primary-50"
                    : idx % 3 === 1
                    ? "bg-background-100"
                    : "bg-accent-50"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-background-50 border border-background-200">
                    <i className={`${r.icon} text-primary-600 text-xl`} />
                  </div>
                  <div className="font-heading text-2xl font-semibold text-foreground-950">
                    {r.stat}
                  </div>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                  {r.title}
                </h3>
                <p
                  className="mt-2 text-foreground-700 text-sm leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: r.body }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}